/* ============================================================
   sc-leg-piping-preview.js
   ------------------------------------------------------------
   Builds CDN URLs for the small "detail" preview images that
   swap as the customer chooses a leg style or piping style in
   the configurator.

   Filename scheme (matches the detail shots on the CDN):
     Piping : <FabricCode>-<PipingDigit>        e.g. O14-1
     Legs   : <FabricCode>-<StyleLetter><FinishDigit>  e.g. O15-W1
   Served from renders/details/ on the CDN, as .jpg by default.

   Leg style letters: Walcot W, Draycot D, Liddington L, Wroughton M.
   Finish digits:     Natural 1, Walnut 2, Ebony 3.

   A placeholder fabric (Snow Drop, O14) stands in when the chosen
   fabric's detail shot isn't on the CDN yet, so the square never
   simply vanishes. Everything is overridable from the product
   template via window.SC_LEG_PIPING_PREVIEW.
   ============================================================ */
(function (global) {
  var SC = global.SC = global.SC || {};

  /* Piping codes — kept in sync with SC.imageResolver's PIPING_CODES. */
  var PIPING_CODES = {
    'self': '1', 'self-flat': '1', 'self-round': '2',
    'contrast': '3', 'contrast-flat': '3', 'contrast-round': '4',
    'oxford': '5', 'soft-edge': '6'
  };

  /* Leg-style codes. Wroughton is M (not its first letter). */
  var LEG_STYLE_CODES = {
    'walcot': 'W', 'draycot': 'D', 'liddington': 'L', 'wroughton': 'M'
  };

  /* Leg-finish digits. */
  var FINISH_CODES = {
    'natural': '1', 'walnut': '2', 'ebony': '3'
  };

  SC.legPipingPreview = {
    config: {
      cdnBase: 'https://cdn.sophieconran.com/renders/details',
      format: 'jpg',
      /* Fabric code used as a stand-in when the selected fabric's detail
         shot isn't available yet. Snow Drop = O14. Set to '' to disable. */
      placeholderFabricCode: 'O14',
      /* Default finish digit when none is selected (Natural). */
      defaultFinish: '1',
      transform: {
        enabled: true,
        width: 440,
        quality: 80,
        format: 'auto'
      }
    },

    /* Merge any CMS-provided overrides set on the page. */
    _applyOverrides: function () {
      var o = global.SC_LEG_PIPING_PREVIEW;
      if (!o) return;
      if (o.cdnBase) this.config.cdnBase = o.cdnBase;
      if (o.format) this.config.format = o.format;
      if (typeof o.placeholderFabricCode === 'string') this.config.placeholderFabricCode = o.placeholderFabricCode;
      if (o.defaultFinish) this.config.defaultFinish = o.defaultFinish;
      if (o.legStyleCodes && typeof o.legStyleCodes === 'object') {
        for (var k in o.legStyleCodes) {
          if (Object.prototype.hasOwnProperty.call(o.legStyleCodes, k)) {
            LEG_STYLE_CODES[k.toLowerCase()] = o.legStyleCodes[k];
          }
        }
      }
      if (o.pipingCodes && typeof o.pipingCodes === 'object') {
        for (var p in o.pipingCodes) {
          if (Object.prototype.hasOwnProperty.call(o.pipingCodes, p)) {
            PIPING_CODES[p.toLowerCase()] = o.pipingCodes[p];
          }
        }
      }
      if (o.finishCodes && typeof o.finishCodes === 'object') {
        for (var f in o.finishCodes) {
          if (Object.prototype.hasOwnProperty.call(o.finishCodes, f)) {
            FINISH_CODES[f.toLowerCase()] = o.finishCodes[f];
          }
        }
      }
      if (o.transform && typeof o.transform === 'object') {
        for (var t in o.transform) {
          if (Object.prototype.hasOwnProperty.call(o.transform, t)) {
            this.config.transform[t] = o.transform[t];
          }
        }
      }
    },

    pipingCode: function (piping) {
      return PIPING_CODES[(piping || '').toLowerCase()] || '';
    },
    legStyleCode: function (legStyle) {
      return LEG_STYLE_CODES[(legStyle || '').toLowerCase()] || '';
    },
    finishCode: function (finish) {
      return FINISH_CODES[(finish || '').toLowerCase()] || '';
    },

    /* The option-code portion of the filename for a group, or '' if not enough. */
    optionCode: function (group, opts) {
      opts = opts || {};
      if (group === 'piping') {
        return this.pipingCode(opts.piping);
      }
      if (group === 'legs') {
        var s = this.legStyleCode(opts.legStyle);
        if (!s) return '';
        var f = this.finishCode(opts.legFinish) || this.config.defaultFinish || '';
        return s + f;
      }
      return '';
    },

    /* Wrap a CDN URL in a Cloudflare image transform. Absolute http(s) only. */
    withTransform: function (url) {
      var tf = this.config.transform;
      if (!tf || !tf.enabled || !url || !/^https?:\/\//i.test(url)) return url;
      if (url.indexOf('/cdn-cgi/image/') !== -1) return url;
      var m = url.match(/^(https?:\/\/[^\/]+)(\/.*)$/i);
      if (!m) return url;
      var opts = [];
      if (tf.width) opts.push('width=' + tf.width);
      if (tf.quality) opts.push('quality=' + tf.quality);
      if (tf.format) opts.push('format=' + tf.format);
      if (!opts.length) return url;
      return m[1] + '/cdn-cgi/image/' + opts.join(',') + m[2];
    },

    /* Build a URL from an explicit fabric code + the option code for the group.
       Filename is hyphenated: <fabricCode>-<optionCode>.<ext> */
    urlFor: function (group, fabricCode, opts) {
      if (!fabricCode || !this.config.cdnBase) return null;
      var optionCode = this.optionCode(group, opts);
      if (!optionCode) return null;
      var base = this.config.cdnBase.replace(/\/$/, '');
      var raw = base + '/' + encodeURIComponent(fabricCode + '-' + optionCode) + '.' + this.config.format;
      return this.withTransform(raw);
    },

    /* Build the preview URL for the selected fabric. */
    url: function (group, opts) {
      opts = opts || {};
      return this.urlFor(group, opts.fabricCode || '', opts);
    },

    /* Build the placeholder (Snow Drop) URL for the same option, or null. */
    placeholderUrl: function (group, opts) {
      var ph = this.config.placeholderFabricCode;
      if (!ph) return null;
      return this.urlFor(group, ph, opts);
    }
  };

  SC.legPipingPreview._applyOverrides();
})(window);
